<template>
  <div class="side-tabs">
    <V3Button :active="value === 'filters'" @click="$emit('update:value', 'filters')">Filters</V3Button>
    <V3Button :active="value === 'views'" @click="$emit('update:value', 'views')">Views</V3Button>
  </div>
</template>

<script>
import V3Button from '../v3dafi/V3Button.vue'
export default {
  name: 'ProtoLeftSideTabs',
  components: { V3Button },
  model: {
    prop: 'value',
    event: 'update:value',
  },
  props: {
    value: String,
  },
}
</script>

<style scoped lang="scss">
.side-tabs {
  display: flex;
  align-items: stretch;
  align-self: stretch;
  height: 2.25rem;
  flex: 0 0 2.25rem;

  & > * {
    flex: 1 1 auto;
  }

  button {
    background-color: #211f2b;
    color: #898795;
    font-size: 0.6875rem;

    &.active {
      filter: drop-shadow(7.726px -12.858px 8px rgb(11 16 20 / 64%));
      background-color: #2f2c3b;
      color: #e8e9ee;
    }
  }

  button:hover {
    background-color: #2f2c3b;
  }
}
</style>
